var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"screenfull"},on:{"click":_vm.click}},[(_vm.isFullscreen)?_c('i',{staticClass:"fas fa-compress-arrows-alt"}):_c('i',{staticClass:"fas fa-expand-arrows-alt"})])
}
var staticRenderFns = []

export { render, staticRenderFns }